import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  user: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload.isLoggedIn;
    },
    setUser: (state, action) => {
      state.user = action.payload.user;
    },
  },
});

export const { setIsLoggedIn, setUser } = userSlice.actions;

export default userSlice.reducer;
